import { Checkbox } from '@mui/material';
import React from 'react';

import { IAccountOption } from '../../../providers/venue-provider';
import { MultiSelectListAccounts } from '../../../components/multi-select/multi-select-list-accounts';
import './styles.scss';

interface AggregatedExchangeAccountListProps {
  exchange: string;
  label: string;
  icon: any;
  credentials: any[];
  isPortfolioSidebarOpen: boolean;
  selectedAccountsAggregated: IAccountOption[];
  setSelectedAccountsAggregated: (items: IAccountOption[]) => void;
  // Opt-in — off by default, unaffected everywhere except where a caller
  // explicitly wants it (Portfolio Performance's "blur names for demo").
  isBlurred?: boolean;
}

export const AggregatedExchangeAccountList: React.FC<AggregatedExchangeAccountListProps> = ({
  exchange,
  label,
  icon,
  credentials,
  isPortfolioSidebarOpen,
  selectedAccountsAggregated,
  setSelectedAccountsAggregated,
  isBlurred = false,
}) => {
  const filteredCredentials = credentials.filter((acc) => acc.exchange === exchange);
  const items: IAccountOption[] = filteredCredentials.flatMap((c) =>
    c.items.map((i: any) => ({
      name: i.name,
      exchange: i.exchange,
      venue: i.venue,
      symbols: i.symbols || [],
      last_tick: i.last_tick || '',
    })),
  );

  const hasOtcSelected = selectedAccountsAggregated.some((sel) => sel.exchange === 'otc');
  const hasNonOtcSelected = selectedAccountsAggregated.some((sel) => sel.exchange !== 'otc');
  const isOtcGroup = exchange === 'otc';
  const disableGroup = isOtcGroup ? hasNonOtcSelected : hasOtcSelected;

  const isAllSelected = items.every((item) =>
    selectedAccountsAggregated.some(
      (sel) => sel.name === item.name && sel.exchange === item.exchange,
    ),
  );
  const handleSelectAllChange = (checked: boolean) => {
    if (disableGroup) return;
    if (checked) {
      const toAdd = items.filter(
        (item) =>
          !selectedAccountsAggregated.find(
            (sel) => sel.name === item.name && sel.exchange === item.exchange,
          ),
      );
      setSelectedAccountsAggregated([...selectedAccountsAggregated, ...toAdd]);
    } else {
      setSelectedAccountsAggregated(
        selectedAccountsAggregated.filter(
          (sel) => !items.find((item) => item.name === sel.name && item.exchange === sel.exchange),
        ),
      );
    }
  };

  return (
    <div className="portfolio-accounts-aggregated-venue">
      {items.length > 0 && (
        <div
          className="portfolio-account-aggregated-label"
          onClick={() => handleSelectAllChange(!isAllSelected)}
        >
          <Checkbox
            checked={isAllSelected}
            onChange={(e) => handleSelectAllChange(e.target.checked)}
            disabled={disableGroup}
          />
          <img src={icon} alt={exchange} />
          <span>{label}</span>
        </div>
      )}

      <div className="portfolio-accounts-multi-select-data">
        <div
          className={`portfolio-accounts-multi-select-list ${
            isPortfolioSidebarOpen ? 'portfolio-accounts-multi-select-hover' : ''
          }`}
        >
          <MultiSelectListAccounts
            items={items}
            selectedItems={selectedAccountsAggregated}
            setSelectedItems={(newItems) =>
              !disableGroup && setSelectedAccountsAggregated(newItems)
            }
            multiSelectDisabled={disableGroup}
            isBlurred={isBlurred}
          />
        </div>
      </div>
    </div>
  );
};
